module.exports = __webpack_public_path__ + "static/media/tech-cxo-button.830804b1.svg";